













































import { Component, InjectReactive, Vue } from 'vue-property-decorator';
import { BvTableFieldArray } from 'bootstrap-vue';

import { FeedTank, Transceiver } from '@/api';
import { transceiverTableFields } from '@/models/transceivers-table-fields';
import { FeedProduct } from '../../models';

import RebootTransceiverButton from '@/components/elements/functional buttons/reboot-transceiver.vue';
import LastCheckInTag from '@/components/display/information-rows/last-check-in-tag.vue';

@Component({
	components: {
		LastCheckInTag,
		RebootTransceiverButton,
	},
})
export default class FeedProductTransceiversTab extends Vue {
	@InjectReactive('feedProduct')
	public feedProduct!: FeedProduct;

	public get transceivers(): (Transceiver & { feedTankName: string | undefined })[] {
		return this.feedProduct.feedtanks
			.filter((feedTank: FeedTank & { transceiver: Transceiver | null }) => feedTank.transceiver)
			.map(feedTank => ({ ...feedTank.transceiver!, feedTankName: feedTank.name }));
	}

	public get transceiverFields(): BvTableFieldArray {
		return transceiverTableFields;
	}
}
